/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Card, Row } from "react-bootstrap";
import Text from "../../../components/Text";
import MapdotPopup from "../MapdotPopup";
import { getConfirmStatus, CONFIRM_COLORS, CONFIRM_DICT_KEYS } from "../../../utils/confirmationStatus";

class MapVenuList extends Component {
  render() {
    const { mapdots, currentCity } = this.props;
    const { dictionary } = this.props.lang;

    if (!mapdots || mapdots.length === 0) {
      return (
        <Card.Body>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "48px 24px",
            textAlign: "center",
          }}>
            <div style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "#eef1fb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
            }}>
              <i className="feather icon-map-pin" style={{ fontSize: 36, color: "#4e6ac5" }} />
            </div>
            <h5 style={{ fontFamily: "Montserrat", color: "#4e6ac5", marginBottom: 8 }}>
              {dictionary.noVenuesListTitle}
            </h5>
            <p style={{ fontFamily: "Montserrat", color: "#888", fontSize: 14, maxWidth: 320, margin: 0 }}>
              {dictionary.noVenuesListMsg}
            </p>
          </div>
        </Card.Body>
      );
    }

    return (
      <Card.Body className="p-0">
        <Row className="gx-3 gy-3">
          {[...mapdots]
            .sort((a, b) => {
              if (a.city === currentCity && b.city !== currentCity) return -1;
              if (a.city !== currentCity && b.city === currentCity) return 1;
              return a.city.localeCompare(b.city);
            })
            .map((mapdot, index) => (
              <Col
                key={index}
                lg={6} // Para pantallas grandes (2 tarjetas por fila)
                sm={12} // Para pantallas más pequeñas (1 tarjeta por fila)
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Card style={{ width: "100%" }}>
                  <Card.Body>
                    <Row>
                      <Col xs={2}>
                        <i
                          className="fa-solid fa-circle-info"
                          style={{
                            fontSize: "20px",
                            color: "#4e6ac5",
                          }}
                        />
                      </Col>
                      <Col>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <h5 style={{ fontFamily: "Montserrat", margin: 0 }}>
                            {(() => {
                              const ownerId = mapdot.ownerMapdot?._id || mapdot.ownerMapdot;
                              const isOwner = ownerId && ownerId.toString() === this.props.auth?.user?.id;
                              if (isOwner) {
                                return (
                                  <Link
                                    to={{
                                      pathname: `/dashboard/bailo-dots/${(mapdot.title || mapdot.publicName || mapdot._id).toString().toLowerCase()}`,
                                      state: `${mapdot._id}`,
                                    }}
                                    style={{ color: "#4e6ac5", fontWeight: "bold" }}
                                  >
                                    {mapdot.title || mapdot.publicName}
                                  </Link>
                                );
                              }
                              return <MapdotPopup mapdot={mapdot} />;
                            })()}
                          </h5>
                          {(() => {
                            const status = getConfirmStatus(mapdot.isMapdotConfirmed);
                            const { dictionary } = this.props.lang;
                            return (
                              <span
                                title={dictionary[CONFIRM_DICT_KEYS[status]] || status}
                                style={{
                                  flexShrink: 0,
                                  width: 10,
                                  height: 10,
                                  borderRadius: "50%",
                                  background: CONFIRM_COLORS[status],
                                  border: "2px solid #fff",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                  display: "inline-block",
                                }}
                              />
                            );
                          })()}
                        </div>
                      </Col>
                    </Row>

                    <hr style={{ margin: "5px 0", border: "1px solid #ccc" }} />

                    <div
                      style={{
                        fontFamily: "Montserrat",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <span>{mapdot.address}</span>
                    </div>
                    <br />
                    <div
                      style={{
                        fontFamily: "Montserrat",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <span>{mapdot.city}</span>
                    </div>
                    <br />

                    <div>
                      <a
                        href={`https://maps.google.com?q=${mapdot.coordinatesLatLong?.lat || mapdot.coordinatesLatLong?.Latitude},${mapdot.coordinatesLatLong?.lng || mapdot.coordinatesLatLong?.Longitude}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Row>
                          <Col xs={2}>
                            <i
                              className="fa-solid fa-directions"
                              style={{
                                fontSize: "20px",
                                color: "#4e6ac5",
                              }}
                            />
                          </Col>
                          <Col>
                            <Text tid="goGoogle" />
                          </Col>
                        </Row>
                      </a>
                    </div>

                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </Card.Body>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  lang: state.lang,
  layout: state.layout,
});

export default connect(mapStateToProps)(MapVenuList);
